import React, { useState, useRef, useEffect, useMemo } from 'react';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import { useWindowWidth } from '@lux/hooks';
import { CarouselWrapper, CarouselItemsWrapper } from './styles';
const SCROLL_EVENT = 'scroll';
const ON_SCROLL_DEBOUNCE_TIMEOUT = 500;
const ON_RESIZE_THROTTLE_TIMEOUT = 200;
function ScrollCarousel(props) {
    const { children, onScroll, initialScroll, carouselLabel, ...rest } = props;
    const [offset, setOffset] = useState(0);
    const carouselWrapperEl = useRef(null);
    const carouselContentsEl = useRef(null);
    useEffect(() => {
        if (onScroll && carouselContentsEl.current) {
            const carouselElementsRef = carouselContentsEl.current;
            const onScrollDebounced = debounce(onScroll, ON_SCROLL_DEBOUNCE_TIMEOUT);
            carouselElementsRef.addEventListener(SCROLL_EVENT, onScrollDebounced);
            return () => {
                carouselElementsRef.removeEventListener(SCROLL_EVENT, onScrollDebounced);
            };
        }
    }, [onScroll]);
    const thottledSetOffset = useMemo(() => throttle(() => {
        var _a;
        setOffset(((_a = carouselWrapperEl.current) === null || _a === void 0 ? void 0 : _a.offsetLeft) || 0);
    }, ON_RESIZE_THROTTLE_TIMEOUT), []);
    const windowWidth = useWindowWidth();
    useEffect(thottledSetOffset, [windowWidth]);
    return (React.createElement(CarouselWrapper, { role: "region", "aria-label": carouselLabel, ref: carouselWrapperEl },
        React.createElement(CarouselItemsWrapper, Object.assign({ className: "carousel-items-wrapper" }, rest, { offset: offset, initialScroll: initialScroll, onRef: carouselContentsEl }), children)));
}
export default ScrollCarousel;
//# sourceMappingURL=component.js.map